var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"virtual-tooltip-element",style:(_vm.style)},[_c(_vm.component,_vm._b({ref:"tooltip",tag:"component",attrs:{"target":() => _vm.$el,"show":_vm.tooltipIsShow}},'component',_vm.$attrs,false),[_vm._t("default",null,{"close":_vm.close})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }